import {get,post,url,fetch} from '../http'

class About{
    //加入我们
    @url("/exam-guide/getExamGuidePage")
    @get
    getExamGuidePage(){}
    @url("exam-guide/getExamGuide")
    @fetch
    getExamGuide(){}


}

export default new About()